/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RrpCalculationType = {
    LocalPricePointRounding: 'LocalPricePointRounding',
    PredefinedLeadToLocalPp: 'PredefinedLeadToLocalPp'
} as const;
export type RrpCalculationType = typeof RrpCalculationType[keyof typeof RrpCalculationType];


export function instanceOfRrpCalculationType(value: any): boolean {
    for (const key in RrpCalculationType) {
        if (Object.prototype.hasOwnProperty.call(RrpCalculationType, key)) {
            if (RrpCalculationType[key as keyof typeof RrpCalculationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RrpCalculationTypeFromJSON(json: any): RrpCalculationType {
    return RrpCalculationTypeFromJSONTyped(json, false);
}

export function RrpCalculationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RrpCalculationType {
    return json as RrpCalculationType;
}

export function RrpCalculationTypeToJSON(value?: RrpCalculationType | null): any {
    return value as any;
}

export function RrpCalculationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RrpCalculationType {
    return value as RrpCalculationType;
}

